import { Component, Input, OnInit  } from '@angular/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-detail-grid',
  templateUrl: './detail-grid.component.html',
  styleUrls: ['./detail-grid.component.scss']
})
export class DetailGridComponent implements OnInit  {
  @Input() data: any;
  holidaydropdown:any=[]
  button={}
  editdata:any;
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang:any;

  constructor(public gt:genericCustomStoreService,public Objects:ObjectsService,public _publicSettingService:publicSettingService,public translate:TranslateService) { 
    this.button=Objects.button;
    gt.getdropdowndata("HolidayType").subscribe(res=>this.holidaydropdown=res) 
    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );

    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
  });

  }
  ngOnInit(): void {}

  updateRow(e:any){
    e.cancel=true;
    this.editdata=e.data;
    this.data.splice(this.data.indexOf(e.data),1)
    this._publicSettingService.$Holiday_Edit_Start.next(true)
  }
}
